import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Create an async thunk for creating project
export const createProject = createAsyncThunk('project/createProject', async (formData, { rejectWithValue }) => {
  const userData = JSON.parse(localStorage.getItem('userData'));
  const userId = userData.user.id;

  let response;
  try {
    response = await fetch(`/api/projects/user/${userId}`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error response data:', errorData);
      // Reject with error data
      return rejectWithValue(errorData.error || 'Project creation failed');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error in createProject thunk', error);
    return rejectWithValue(error.message || 'An error occurred during the API call');
  }
});

const createProjectSlice = createSlice({
  name: 'project',
  initialState: { project: null, status: 'idle', error: null },
  reducers: {
    resetStatus: (state) => {
      state.status = 'idle';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createProject.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(createProject.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.project = action.payload;
      })
      .addCase(createProject.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      });
  },
});

export const { resetStatus } = createProjectSlice.actions;
export default createProjectSlice.reducer;
